import { Expose } from 'class-transformer';
import { IsDefined, IsNotEmpty, IsString } from '@lgce/class-validator';

export class CreateAgencyDto {
    @Expose()
    public id!: string;

    @IsDefined()
    @IsString()
    @IsNotEmpty()
    @Expose()
    public label!: string;

    @IsDefined()
    @IsString()
    @IsNotEmpty()
    @Expose()
    public code!: string;
}
